
/* ============================== src/context/ConfirmContext.js ============================== */
// src/context/ConfirmContext.js
import { createContext, useContext } from "react";

export const ConfirmContext = createContext(null);

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx;
};
